import type { IOcrkV1CustomControlData } from './ocrkV1RequestCustomControlData';

export enum OorkRedenKeuring {
    diabetesMellitus = 'Diabetes Mellitus',
    onderBehandelingOogarts = 'Onder behandeling bij een oogarts',
    overig = 'Overige reden',
    vijfEnZeventigPlus = '75+',
}

export enum RefractieOptimaleCorrectie {
    groterDanGelijkAan8D = '≥8D',
    kleinerDan8D = '<8D',
}

export enum GestoordeDonkerAdaptie {
    jaGroterDanLogeenheid = 'Ja, > 1 logeenheid',
    jaKleinerDanGelijkAanLogeenheid = 'Ja, ≤ 1 logeenheid',
    nee = 'Nee',
}

export enum RijbewijsCategorie {
    groep1 = 'Groep 1: Rijbewijzen categorieën A1, A2, A, B, B+, E en T',
    groep2 = 'Groep 2: Rijbewijzen categorieën C, C1, CE, C1E, D, D1, DE, DTE',
}

export interface IEigenCorrectie {
    bril: boolean;
    contactlenzen_overdag: boolean;
    geen_eigen_correctie: boolean;
    nachtlenzen: boolean;
}

export interface IVisusFields {
    visus_eigen_correctie_od: string | null;
    visus_eigen_correctie_ods: string | null;
    visus_eigen_correctie_os: string | null;
    visus_optimale_correctie_od: string | null;
    visus_optimale_correctie_ods: string | null;
    visus_optimale_correctie_os: string | null;
    visus_zonder_correctie_od: string | null;
    visus_zonder_correctie_ods: string | null;
    visus_zonder_correctie_os: string | null;
}

export interface IOorkV1ProcedureCustomControlData extends IVisusFields {
    aanwijzingen_defecten_gezichtsveld: boolean | null;
    beschrijving_gezichtsvelddefecten: string | null;
    betrokkene_bezit_rijbewijs: boolean | null;
    betrokkene_gebruikt_hulpmiddel: boolean | null;
    bsn_betrokkene?: string | null;
    categorie_rijbewijs: RijbewijsCategorie | null;
    consult: IOcrkV1CustomControlData;
    datum_onderzoek: string | null;
    diplopie_is_hinderlijk: boolean | null;
    eigen_correctie: IEigenCorrectie;
    email_betrokkene: string | null;
    files: string[];
    gestoorde_donkeradaptie: GestoordeDonkerAdaptie | null;
    homePhoneNumber: string | null;
    inspection_rights_consented: boolean | null;
    legitimatie_betrokkene_gezien: boolean | null;
    mobileNumber: string | null;
    overige_anamnese: string | null;
    overige_reden_van_keuring: string | null;
    reden_van_keuring: OorkRedenKeuring | null;
    refractie_optimale_correctie: RefractieOptimaleCorrectie | null;
    share_medical_info_consented: boolean | null;
    sprake_van_diplopie: boolean | null;
    toelichting_diplopie: string | null;
    toelichting_donkeradaptie: string | null;
    zorgdomein_code: string | null;
}
